import React, { useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
// import makeAnimated from 'react-select/animated';
import Fuse from "fuse.js";

// Selector styles
const groupStyles = {
  display: "flex",
  alignItems: "left",
  justifyContent: "space-between",
  textAlign: "left",
};
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "left",
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

function SelectorMulti(props) {
  const groupedContentOptions = [];

  // Dropdown Option List
  if (props.filterType === "content") {
    // eDNA data
    const contentOptions = props.options;
    // console.log(contentOptions);

    var dbShowList = contentOptions.filter(function (el) {
      return el.type === "Show";
    });

    var dbMovieList = contentOptions.filter(function (el) {
      return el.type === "Movie";
    });

    // var dbNetworkList = contentOptions.filter(function (el)
    // {
    //     return el.type === 'Network';
    // });

    groupedContentOptions.push(
      {
        label: "Show",
        options: dbShowList,
      },
      {
        label: "Movie",
        options: dbMovieList,
      }
      // {
      //     label: 'Network',
      //     options: dbNetworkList,
      // },
    );
  } else if (props.filterType === "contentType") {
    groupedContentOptions.push(
      { value: "Show", label: "Show", tag: "contentType" },
      { value: "Movie", label: "Movie", tag: "contentType" }
    );
  } else if (props.filterType === "genre") {
    props.options.length > 1 &&
      props.options.map((option, index) =>
        groupedContentOptions.push({
          value: option,
          label: option,
          tag: "genre",
        })
      );
    // groupedContentOptions.push(
    //   { value: "Comedy", label: "Comedy", tag: "genre" },
    //   { value: "Drama", label: "Drama", tag: "genre" },
    //   { value: "Unscripted", label: "Unscripted", tag: "genre" }
    //   // { value: '-', label: 'Movie', tag: 'genre' },
    // );
  } else if (props.filterType === "network") {
    props.options.map((network, index) => groupedContentOptions.push(network));
  } else if (props.filterType === "rating") {
    groupedContentOptions.push(
      // { value: '5', label: '⭐⭐⭐⭐⭐', tag: 'rating' },
      { value: "4", label: "⭐⭐⭐⭐", tag: "rating" },
      { value: "3", label: "⭐⭐⭐", tag: "rating" },
      { value: "2", label: "⭐⭐", tag: "rating" },
      { value: "1", label: "⭐", tag: "rating" }
    );
  } else if (props.filterType === "reach") {
    groupedContentOptions.push(
      // { value: '5', label: '⭐⭐⭐⭐⭐', tag: 'rating' },
      { value: "40", label: "Over 20", tag: "reach" },
      { value: "20", label: "10-20", tag: "reach" },
      { value: "10", label: "5-10", tag: "reach" },
      { value: "5", label: "2-5", tag: "reach" },
      { value: "2", label: "Below 2", tag: "reach" }
    );
  }

  // Fuse (fuzzy search)
  const fuseOptions = {
    includeScore: true,
    threshold: 0.7,
    keys: ["label"],
  };
  const [fuseList, setFuseList] = useState();
  const fuse = new Fuse(
    groupedContentOptions[0].options &&
      groupedContentOptions[0].options.concat(groupedContentOptions[1].options),
    fuseOptions
  );
  const fuseShow = new Fuse(groupedContentOptions[0].options, fuseOptions);
  const fuseMovie = new Fuse(groupedContentOptions[1].options, fuseOptions);

  let fuseFilter;
  const labels = [];
  if (props.filterType !== "content") {
    groupedContentOptions.map((option) => labels.push(option.label));
    fuseFilter = new Fuse(labels, fuseOptions);
  }

  const [fuzzyValues, setFuzzyValues] = useState([]);
  const handleInputChange = (inputValue) => {
    if (!inputValue) {
      setFuseList(groupedContentOptions);
    } else {
      if (props.filterType !== "content") {
        const results = fuseFilter.search(inputValue);
        const resultsValue = [];
        results.map((result) => resultsValue.push(result.item));
        setFuzzyValues(resultsValue);
        const filteredList = resultsValue.map((item) =>
          groupedContentOptions.find((o) => o.label === item)
        );

        setFuseList(filteredList);
      } else {
        //get the character entered by user here in inputValue
        const results = fuse.search(inputValue);
        const resultsShow = fuseShow.search(inputValue);
        const resultsMovie = fuseMovie.search(inputValue);

        const resultsValue = [];
        const resultsValueShow = [];
        const resultsValueMovie = [];
        results.map((result) => resultsValue.push(result.item.value));
        resultsShow.map((result) => resultsValueShow.push(result.item.value));
        resultsMovie.map((result) => resultsValueMovie.push(result.item.value));

        setFuzzyValues(resultsValue);
        setFuzzyValues(resultsValueShow.concat(resultsValueMovie));

        // Filter and sort by fuzzy score
        // const filteredListShow = resultsValueShow.map((id) =>
        //   groupedContentOptions[0].options.find((o) => o.value === id)
        // );
        // const filteredListMovie = resultsValueMovie.map((id) =>
        //   groupedContentOptions[1].options.find((o) => o.value === id)
        // );

        // const filteredList = [
        //   {
        //     label: "Show",
        //     options: filteredListShow,
        //   },
        //   {
        //     label: "Movie",
        //     options: filteredListMovie,
        //   },
        // ];

        const filteredList = resultsValue.map((id) =>
          groupedContentOptions[0].options
            .concat(groupedContentOptions[1].options)
            .find((o) => o.value === id)
        );

        setFuseList(filteredList);
      }
    }
  };

  // Filter logics
  const filterOptions = (candidate, input) => {
    if (input) {
      if (props.filterType === "content") {
        return fuzzyValues.includes(candidate.value);
      } else {
        return fuzzyValues.includes(candidate.label);
      }
    }
    return true;
  };

  const loadOptions = (inputValue, callback) => {
    const options = fuseList ? fuseList : groupedContentOptions;
    const filter = (input) => {
      return options.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      );
    };
    callback(filter(inputValue));
  };

  const SelectElement = props.filterType === "content" ? AsyncSelect : Select;

  return (
    <div
      className={`w-full text-left ${
        props.styleType === "result"
          ? "text-sm font-extrabold"
          : "text-[16px] italic font-semibold"
      }`}
    >
      <div className={`${props.width && props.width}`}>
        <SelectElement
          closeMenuOnSelect={false}
          isMulti
          placeholder={props.placeholder}
          loadOptions={loadOptions}
          options={fuseList ? fuseList : groupedContentOptions}
          noOptionsMessage={({ inputValue }) => {
            let display = "Loading...";
            if (props.filterType !== "content") {
              display = "No match found.";
            } else if (!inputValue) {
              display = "Search for a show or movie.";
            } else if (props.options.length > 1) {
              display =
                "Oops! This show isn't in our Beta version yet, but we're adding new titles regularly!";
            }
            return display;
          }}
          formatGroupLabel={formatGroupLabel}
          onChange={props.handleChange}
          onInputChange={handleInputChange}
          value={props.value.length > 0 && props.value}
          // components={animatedComponents}
          blurInputOnSelect={false}
          filterOption={filterOptions}
          isSearchable={props.filterType === "rating" ? false : true}
        />
      </div>
    </div>
  );
}

export default SelectorMulti;
